// Import React for component creation
import React from "react";
// Import Link for navigation
import { Link } from "react-router-dom";
// Import CSS for header styling
import "../../css/Header.css";
// Import logo image
import HeaderImage from "../../assets/images/Logo-light 1.png";

/**
 * Header component for displaying the site logo and navigation links.
 *
 * Sections:
 * - Logo: Links to the homepage
 * - Navigation: Links to About Us, Services, Blogs, and Contact Us pages
 */
const Header = () => (
  <header className="main-header">
    {/* Logo section with link to homepage */}
    <div className="header-logo">
      <Link to="/">
        <img src={HeaderImage} alt="Oakmont Financial Services Logo" />
      </Link>
    </div>
    {/* Navigation links */}
    <div className="header-nav">
      <Link to="/about" className="nav-items">
        About Us
      </Link>
      <Link to="/services" className="nav-items">
        Services
      </Link>
      <Link to="/blogs" className="nav-items">
        Blogs
      </Link>
      <Link to="/contact" className="nav-items">
        Contact Us
      </Link>
    </div>
  </header>
);

// Export the Header component as default
export default Header;
